import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { SHOW_TRAILER } from '../config/features';
const BASE_NAV_ITEMS = [{
  label: 'Gallery',
  href: '#gallery'
}, {
  label: 'Trailer',
  href: '#trailer'
}, {
  label: 'Screening Room',
  href: '#screening-room'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const firstMenuItemRef = useRef<HTMLButtonElement>(null);
  const navItems = SHOW_TRAILER ? BASE_NAV_ITEMS : BASE_NAV_ITEMS.filter(item => item.label !== 'Trailer');
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (!menuOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    firstMenuItemRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [menuOpen]);
  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${scrolled ? 'border-b border-led/10 bg-ink/80 backdrop-blur-md' : 'bg-transparent'}`} data-id="element-133" data-mp="1a5ynm5mkvkef">
        <nav className="mx-auto flex max-w-[1800px] items-center justify-between px-5 py-5 sm:px-8 lg:px-10" data-id="element-134" data-mp="1k3wbut4fth71">
          <a href="#top" onClick={event => {
          event.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="font-heading text-sm uppercase tracking-[0.3em] text-led focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" data-id="element-135" data-mp="ufh37z5yjdjc">
            Doors of Perception
          </a>

          <ul className="hidden items-center gap-8 md:flex" data-id="element-136" data-mp="1d5yudzb5612l">
            {navItems.map(item => <li key={item.href} data-id="element-137" data-mp="187wz8g0fybar">
                <button type="button" onClick={() => handleNavClick(item.href)} className="text-xs uppercase tracking-[0.2em] text-led/70 transition-colors duration-300 hover:text-ice focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ice" data-id="element-138" data-mp="186vnsafijmsi">
                  {item.label}
                </button>
              </li>)}
          </ul>

          <button type="button" onClick={() => setMenuOpen(true)} className="text-led focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice md:hidden" aria-label="Open menu" data-id="element-139" data-mp="3jzapewju99dn">
            <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-140" data-mp="1po2mkuhm7obr" />
          </button>
        </nav>
      </header>

      <AnimatePresence data-id="element-141" data-mp="1umvyiih9779t">
        {menuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-50 flex flex-col bg-ink/98 backdrop-blur-md md:hidden" role="dialog" aria-modal="true" aria-label="Site navigation" data-id="element-142" data-mp="1gofig0xi44f0">
            <div className="flex justify-end px-5 py-5" data-id="element-143" data-mp="1brfcrr4kd3of">
              <button type="button" onClick={() => setMenuOpen(false)} className="text-led focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" aria-label="Close menu" data-id="element-144" data-mp="315aon94sgscr">
                <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-145" data-mp="1129ia8gfmo2h" />
              </button>
            </div>
            <ul className="flex flex-1 flex-col items-center justify-center gap-8" data-id="element-146" data-mp="x064vea7d9ek">
              {navItems.map((item, index) => <li key={item.href} data-id="element-147" data-mp="s0jqh1in1n46" data-mpi={index}>
                  <button ref={index === 0 ? firstMenuItemRef : undefined} type="button" onClick={() => handleNavClick(item.href)} className="font-heading text-3xl uppercase tracking-[0.1em] text-led focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" data-id="element-148" data-mp="s3o2um69bp5x">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </>;
}